module.exports = __webpack_public_path__ + "img/movie.072c4b69.jpeg";